import { testimonials } from "@/mocks/comics";

export default function Testimonials() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="text-center">
        <p className="text-sm font-bold text-primary-600">读者口碑</p>
        <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">
          百万追更读者的选择
        </h2>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
        {testimonials.map((t) => (
          <figure
            key={t.name}
            className="flex flex-col rounded-lg border border-background-200/70 bg-background-100 p-6"
          >
            <div className="flex text-accent-500">
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
            </div>
            <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
              「{t.text}」
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3">
              <img
                src={t.avatar}
                alt={`${t.name} 头像`}
                className="h-10 w-10 rounded-full object-cover"
              />
              <div>
                <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                <p className="text-xs text-foreground-500">{t.role}</p>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}